import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import MonthsDropdown from '../../MonthsDropdown';
import SegmentsTransitionsChart from '../../SegmentsTransitionsChart';
import TransitionsTable from '../../TransitionsTable';
import Button from '../../../../../components/Buttons/Button';
import CollapsibleSlot from '../../../../../components/CollapsibleSlot';
import ErrorStateWithReload from '../../../../../components/ErrorStateWithReload';
import { usageTransitionsSelector } from '../../../selectors';
import { fetchUsageTransitions } from '../../../actions';

const emptyObject = {};

const UsageTransitions = () => {
  const dispatch = useDispatch();

  const { settings, data, filters } = useSelector(usageTransitionsSelector);

  const [isOpen, setOpen] = useState(false);

  const handlePeriodChange = (value) => {
    dispatch(fetchUsageTransitions({ month_date: value }));
  };

  if (settings.error) return <ErrorStateWithReload className="py-xl" />;

  return (
    <div className="usage-transitions">
      <header className="section-body-header">
        <div className="section-body-header__left">
          <h4 className="section-body-header__title">Usage Frequency Transitions</h4>
          <p className="section-body-header__description">
            Visualizes how users move between AI usage segments across periods.
          </p>
        </div>
        <div className="section-body-header__right">
          <MonthsDropdown
            selected={filters.month_date}
            disabled={settings.pending}
            onChange={handlePeriodChange}
          />
          <div className="section-separator--v" />
          <Button
            shape="square"
            variant="secondary"
            active={isOpen}
            onClick={() => setOpen((open) => !open)}
          >
            <span className="hicon-list-button" />
          </Button>
        </div>
      </header>
      <SegmentsTransitionsChart settings={settings} data={data} selectedDate={filters.month_date} />
      <CollapsibleSlot show={isOpen} className="toggle-collapsible--slide-in-out">
        <TransitionsTable data={data.table_data || emptyObject} isPending={settings.pending} />
      </CollapsibleSlot>
    </div>
  );
};

export default UsageTransitions;
